import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import {
  CancellationPolicy,
  PropertyAttachmentType,
  ResponseData,
} from "./common"

interface PropertyRequestData {
  propertyId: string
  avoidClientSideAuth?: boolean
}

export interface PropertyRequest extends Partial<AxiosRequestConfig> {
  params: PropertyRequestData
}

export interface PaymentScheduleConfig {
  isDefault: number
  paymentScheduleDay: number
}

export type PaymentScheduleMap = Record<number, PaymentScheduleConfig>

export interface PaymentSchedule {
  days: string
  paymentScheduleDay: number
}

export interface PropertyResponseData extends ResponseData {
  data: {
    cancellationPolicy?: CancellationPolicy | null
    propVideo?: PropertyAttachmentType[] | null
    startDate?: string
    endDate?: string
    cancelPolicyDatelessText?: string
    cancelPolicyFutureRefundText?: string
    cancelPolicyPastRefundText?: string
    stagePaymentConfig?: PaymentScheduleMap | null
  }
}

export interface PropertyResponse extends AxiosResponse {
  data: PropertyResponseData
}

export function getPropertyAdditionalInfoApi(
  {
    params,
    method = "get",
    url = `/property/additional-info/${params.propertyId}`,
    ...config
  }: PropertyRequest,
  axiosInstance: AxiosInstance,
): Promise<PropertyResponse> {
  return axiosInstance({
    ...(params.avoidClientSideAuth
      ? {
          data: {
            avoidClientSideAuth: false,
          },
        }
      : {}),
    method,
    url,
    ...config,
  }) as Promise<PropertyResponse>
}
